export default {
  path: '/date-logout-rule',
  component: () => import('./DateLogoutAgreement'),
  meta: {
    title: '注销须知',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
